<div class="main">
  <div id="content">
    <router-outlet></router-outlet>
    <!--    <ng-content></ng-content> &lt;!&ndash; Platz für Content-Children &ndash;&gt;-->
  </div>
</div>
